import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";
import { getLegalDoc } from "../content/legal/legalRegistry.js";
import NotFoundPage from "./NotFoundPage.jsx";

/**
 * Public legal page (Privacy Policy, Terms & Conditions). Renders the markdown
 * source with the shared site-page / contract-prose styling.
 *
 * @param {{ slug: string }} props
 */
export default function LegalPage({ slug }) {
  const doc = slug ? getLegalDoc(slug) : null;

  if (!doc) {
    return <NotFoundPage />;
  }

  return (
    <article className="site-page site-page--contract">
      <div className="site-page__inner site-page__inner--contract">
        <div className="contract-prose">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{doc.body}</ReactMarkdown>
        </div>

        <p className="site-page__muted">
          <Link to="/privacy">Privacy Policy</Link>
          {" · "}
          <Link to="/terms">Terms &amp; Conditions</Link>
          {" · "}
          <Link to="/contact">Contact</Link>
        </p>
      </div>
    </article>
  );
}
